<span
  autoClose="true"
  [ngbPopover]="popContent"
  container="body"
  triggers="hover"
  (shown)="handleShow(ticket.hd_ticket_number)"
  (hidden)="handleHide()"
  class="description"
  #p="ngbPopover"
>
  {{ $safeNavigationMigration(ticket?.extra_flags?.gp_text) | func: truncateString : 100 }}
</span>

<ng-template #popContent>
  <app-loader [size]="'small'" [position]="'reset'" *ngIf="loading; else loadedContent"></app-loader>
</ng-template>

<ng-template #loadedContent>
  {{ gp_text }}
</ng-template>
